import { UploadEmployeesTranslation } from '@/assets/locales/views/uploadEmployees/uploadEmployees.translation.en';

export const uploadEmployeesTranslation: UploadEmployeesTranslation = {
  fileTypes: {
    CHAT_DOCUMENT: {
      description: 'Dodaje dokument do bazy wiedzy asystenta czatu',
      label: 'Dokument czatu',
    },
    COMPANY_POSITIONS: {
      description: 'Aktualizuje stanowiska firmowe i strukturę organizacyjną',
      label: 'Stanowiska firmowe',
    },
    DEVELOPMENT_ACTIVITIES: {
      description:
        'Importuje aktywności rozwojowe pracowników (np. FRIS, BTM, Coaching) z pliku macierzowego, dopasowując po numerze SAP',
      label: 'Aktywności rozwojowe',
    },
    EDUAKCJA: {
      description: 'Aktualizuje dane edukacyjne i szkoleniowe pracowników',
      label: 'Dane edukacyjne',
    },
    EMPLOYEES: {
      description:
        'Aktualizuje podstawowe informacje o pracownikach (imię, nazwisko, SAP ID, stanowisko, dział)',
      label: 'Pracownicy',
    },
    EMPLOYEES_EMPLOYMENT_HISTORY: {
      description: 'Aktualizuje historie zatrudnienia i ścieżki karier pracowników',
      label: 'Historia zatrudnienia',
    },
    EMPLOYEES_ENABLE_CHANGE: {
      description: 'Aktualizuje status pracowników (aktywny/nieaktywny)',
      label: 'Status pracowników',
    },
    MDR: {
      description: 'Aktualizuje dane MDR (Management Development Review)',
      label: 'Dane MDR',
    },
    SYSTEM_USERS: {
      description: 'Aktualizuje użytkowników systemu i uprawnienia dostępu',
      label: 'Użytkownicy systemu',
    },
  },
  form: {
    downloadFileTemplateLabel: 'Pobierz plik wzorcowy',
    dropzoneLabel: 'Przeciągnij i upuść plik tutaj, lub kliknij aby wybrać plik',
    dropzoneLabel2: '(akceptowane formaty: .xls, .xlsx)',
    fileTypeDescription: 'Co zostanie zaktualizowane:',
    resetButton: 'Resetuj',
    uploadButton: 'Importuj',
    uploadFileLabel: 'Załaduj plik',
    uploadFileType: 'Typ pliku do zaimportowania',
  },
  mdrCareerPathsWarning: {
    cancelButton: 'Anuluj',
    confirmButton: 'Importuj i nadpisz',
    description:
      'Ścieżki kariery pracowników z pliku zostaną zastąpione tymi z pliku. Dotyczy to zarówno profilu pracownika, jak i modułu sukcesji.',
    manualPathsNotice:
      'Ścieżki dodane ręcznie w module sukcesji zostaną dla tych pracowników usunięte. Tej operacji nie można cofnąć.',
    scopeNotice: 'Pracownicy, których nie ma w pliku, pozostaną bez zmian.',
    title: 'Ścieżki kariery zostaną nadpisane',
  },
  modal: {
    closeButton: 'Zamknij',
    downloadErrorButton: 'Pobierz błąd',
    errorOccurred: 'Wystąpił błąd podczas importowania',
    errorTitle: 'Błąd importowania',
    uploadingMessage: 'Importowanie danych, proszę czekać...',
    uploadingTitle: 'Importowanie danych',
  },
  toast: {
    employeesUploadedFileError:
      'Wystąpił błąd podczas importowania pracowników, załączony plik jest nieprawidłowy',
    employeesUploadedGeneralError:
      'Wystąpił błąd podczas importowania pracowników, spróbuj ponownie później',
    employeesUploadedSuccessfully: 'Pracownicy zostali pomyślnie zaimportowani',
  },
  validationErrors: {
    actions: {
      cancel: 'Anuluj',
      cannotResolveOtherType:
        'Nie można automatycznie rozwiązać błędów typu "Inne" - rozwiąż je pojedynczo',
      close: 'Zamknij',
      closeAndReupload: 'Zamknij i wgraj ponownie',
      continue: 'Kontynuuj',
      replaceFile: 'Podmień plik',
      resolve: 'Rozwiąż',
      resolveAll: 'Rozwiąż wszystkie',
      resolveAllOfType: 'Rozwiąż wszystkie tego typu',
      resolveAllVisible: 'Rozwiąż widoczne',
      viewDetails: 'Wyświetl szczegóły',
    },
    allErrorsResolvedMessage:
      'Wszystkie błędy walidacji zostały rozwiązane. Możesz teraz kontynuować wgrywanie.',
    allErrorsResolvedTitle: 'Wszystkie błędy rozwiązane',
    businessErrorTypes: {
      BIRTHDAY_DATE_CHANGED: 'Zmiana daty urodzenia',
      COMPANY_POSITION_DATA: 'Dane stanowiska firmowego',
      EMPLOYEE_ENABLE_INVALID_VALUE: 'Nieprawidłowa wartość statusu pracownika',
      EMPLOYEE_POSITION_CONSISTENCY: 'Spójność stanowiska pracownika',
      EMPLOYEE_REQUIRED_FIELDS: 'Brakujące wymagane pola',
      FUNCTIONAL_GROUP_LEVEL_HIERARCHY_INVALID: 'Nieprawidłowa hierarchia poziomu grupy funkcyjnej',
      HRBP_CHANGED: 'Zmiana HRBP',
      OTHER: 'Inne',
      P1_SUPERVISOR_CHANGED: 'Zmiana przełożonego P+1',
      P2_SUPERVISOR_CHANGED: 'Zmiana przełożonego P+2',
      SYSTEM_USER_INVALID_ENABLED_VALUE: 'Nieprawidłowa wartość pola aktywności',
    },
    columns: {
      actions: 'Akcje',
      column: 'Kolumna',
      count: 'Liczba',
      errorName: 'Nazwa błędu',
      errorType: 'Typ błędu',
      level: 'Poziom',
      message: 'Komunikat',
      row: 'Wiersz',
      severity: 'Poziom',
    },
    criticalErrorMessage:
      'Plik zawiera błędy strukturalne (np. brakujące kolumny) i nie może zostać przetworzony. Wymagane jest poprawienie pliku i ponowne wgranie.',
    criticalErrorsFound: 'Znaleziono błędy krytyczne',
    criticalErrorTitle: 'Błąd krytyczny walidacji',
    detailsTitle: 'Szczegóły błędów',
    goToPage: 'Przejdź do strony',
    noErrors: 'Brak błędów',
    replaceFileDialog: {
      acceptedFormats: '(akceptowane formaty: .xls, .xlsx)',
      description: 'Wgraj nowy plik, aby podmienić obecny. Walidacja rozpocznie się od nowa.',
      dropzoneLabel: 'Przeciągnij i upuść plik tutaj, lub kliknij aby wybrać plik',
      title: 'Podmień plik',
      uploadButton: 'Wgraj',
    },
    status: {
      resolved: 'Rozwiązany',
    },
    subtitle: 'Przejrzyj i rozwiąż błędy wykryte podczas walidacji pliku',
    summaryTitle: 'Podsumowanie błędów wg typu',
    title: 'Błędy walidacji',
    uploadInfo: {
      fileName: 'Nazwa pliku',
      fileType: 'Typ pliku',
      title: 'Informacje o pliku',
      uploadDate: 'Data wgrania',
    },
    validationInfoMessage:
      'Plik zawiera błędy walidacji. Możesz rozwiązać błędy w systemie lub poprawić plik i wgrać go ponownie.',
    validationInfoTitle: 'Informacja o walidacji',
  },
};
